<template>
<div class="chapter">
<div class="inner_page">
<div id="Foreword">
<p class="fm-title" id="for"><a id="pagexv">Foreword</a></p><a id="pagexv">
<p class="noindent">There have been so many books written on Normandy that the publication of another one might initially seem rather superfluous. But <i>Stout Hearts</i> is different. Most books have so far focused on narrating the sequence of the various battles, describing the factors which have influenced their outcome and debating the various merits of Allied and German armies. There is also a further genre of books satisfying the needs of a rather smaller readership which cover individual equipment or units. What has been missing is a book that attempts to describe, for the uninitiated, how an army actually operates in war; how it integrates with the other two Services and what it was like for those involved. <i>Stout Hearts</i> fills this gap, explaining how the many different arms and units within 21st Army Group operated during the Normandy campaign. How, for instance, does the artillery know precisely where to drop its shell? How does an individual tank operate? How are the wounded cared for? How were the Air Force and Navy able to support them?</p>
<p class="para">As someone who landed at Juno Beach on D+1 and fought in the front line through most of the Normandy Campaign until I was wounded, Ben Kite’s explanations bring back many emotive memories of the realities, the noise and appalling destruction of those stirring and dangerous days; and I can vouch for their authenticity and accuracy. I also believe that his fascinating descriptions of operational procedures and tactics interspersed, with numerous personal accounts of how individual soldiers faced up to those dangers and realities, will be of interest to all students of military history who would wish to have a clear idea how a battle is orchestrated, managed and professionally carried out.</p>
<p class="para">With so many personal memories myself I am glad Ben Kite has chosen the Normandy Campaign as the background to his study of an Army at War and I warmly commend it.</p>
<p class="right" style="margin-top:1em;">Field Marshal the Lord Bramall, KG, GCB, OBE, MC</p>
</a></div><a id="pagexv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Foreword.vue?d4156e9c